<script>
  import Clock from "common/icons/Clock.svelte";
  import Play from "common/icons/Play.svelte";

  export let width;
  export let height;
  export let src;
  export let muted = false;
  export let pending = false;

  const offset = 20;
</script>

<style>
  img {
    display: block;
  }
  img.muted {
    filter: grayscale(0.9) brightness(0.6);
  }
  .image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 12px 12px -15px #444;
    box-sizing: border-box;
    border-radius: 5px;
    color: rgba(255, 255, 255, 0.8);
    user-select: none;
    background: linear-gradient(to bottom, #1f1f1f 0%, #000000 100%);
    overflow: hidden;
  }
</style>

<div
  class="relative image-container"
  style="width:{width}px; height:{height}px;">
  {#if src && src != ""}
    <img
      on:error={() => (src = null)}
      {width}
      {height}
      {src}
      alt="Thumbnail"
      loading="lazy"
      class:muted
      style="width:{width}px; height:{height}px;" />
  {/if}

  {#if pending}
    <Clock width="60" height="60" class="absolute filter drop-shadow-md" />
  {:else if !muted}
    <Play width="60" height="60" class="absolute filter drop-shadow-md" />
  {/if}
</div>
